import React, {useState} from 'react'
import './style.css'

export default function YouTubeVideo({videoId}) {
    const [embedAllowed, setEmbedAllowed] = useState(false)

    if(!videoId) {
        return null
    }

    if (!embedAllowed) {
        return (
            <div className={"youtube-wrap"}>
                <button type="button" onClick={() => setEmbedAllowed(true)}>Video laden</button>
                <p>De video wordt pas na je keuze geladen vanaf YouTube.</p>
            </div>
        )
    }

    const embedUrl = `https://www.youtube-nocookie.com/embed/${videoId}`

    return (
        <div className={"youtube-wrap"}>
            <iframe
                src={embedUrl}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen={true}
            />
        </div>
    )
}
